import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setAssignedCustomers,
  setCustomerOptions,
  updateCustomerInState,
  addCustomerToState,
  removeCustomerFromState,
} from "../../../../../redux/mgmtCo/managementCustomerSlice";
import {
  fetchAllCustomers,
  fetchAssignedCustomers,
  addCustomer,
  removeCustomer,
  updateCustomer,
  createNewCustomer,
} from "../services/managementCustomerService";

export const useManagementCustomers = (managementID) => {
  const dispatch = useDispatch();
  const { assignedCustomers, customerOptions } = useSelector(
    (state) => state.managementCustomers
  );

  const loadCustomerOptions = useCallback(async () => {
    try {
      const options = await fetchAllCustomers();
      dispatch(setCustomerOptions(options));
    } catch (error) {
      console.error("Error loading customer options:", error);
    }
  }, [dispatch]);

  const loadCustomerOptionsWithManagementNull = useCallback(async () => {
    try {
      const options = await fetchAllCustomers();
      const filteredOptions = options.filter(
        (option) => option.managementID === null
      );
      dispatch(setCustomerOptions(filteredOptions));
    } catch (error) {
      console.error(
        "Error loading customer options with management null:",
        error
      );
    }
  }, [dispatch]);

  const loadAssignedCustomers = useCallback(async () => {
    if (managementID) {
      try {
        const customers = await fetchAssignedCustomers(managementID);
        dispatch(setAssignedCustomers(customers));
      } catch (error) {
        console.error("Error loading assigned customers:", error);
      }
    }
  }, [managementID, dispatch]);

  const addCustomerToManagement = useCallback(
    async (customerID) => {
      if (managementID && customerID) {
        try {
          const newCustomer = await addCustomer(managementID, customerID);
          dispatch(addCustomerToState(newCustomer));
        } catch (error) {
          console.error("Error adding customer:", error);
        }
      }
    },
    [managementID, dispatch]
  );

  const removeCustomerFromManagement = useCallback(
    async (customerID) => {
      if (managementID && customerID) {
        try {
          await removeCustomer(managementID, customerID);
          dispatch(removeCustomerFromState(customerID));
        } catch (error) {
          console.error("Error removing customer:", error);
        }
      }
    },
    [managementID, dispatch]
  );

  const updateCustomerData = useCallback(
    async (customerID, customerData) => {
      try {
        const updated = await updateCustomer(customerID, customerData);
        dispatch(updateCustomerInState(updated));
      } catch (error) {
        console.error("Error updating customer:", error);
      }
    },
    [dispatch]
  );

  const createNewCustomerInManagement = useCallback(async (customerData) => {
    try {
      const created = await createNewCustomer(customerData);
      // Optionally dispatch if you want to update customerOptions or assignedCustomers
      return created;
    } catch (error) {
      console.error("Error creating new customer:", error);
    }
  }, []);

  return {
    assignedCustomers,
    customerOptions,
    loadCustomerOptions,
    loadCustomerOptionsWithManagementNull,
    loadAssignedCustomers,
    addCustomerToManagement,
    removeCustomerFromManagement,
    updateCustomerData,
    createNewCustomerInManagement,
  };
};
